import { lazy } from "react";
import EmojiTransportationIcon from "@mui/icons-material/EmojiTransportation";

const OrganizationVendorList = lazy(() => import("../organizationVendorList"));
const OrganizationVendorView = lazy(() => import("../organizationVendorView"));
const OrgVendorCabs = lazy(() => import("../orgVendorCab"));
const OrgVendorDrivers = lazy(() => import("../orgVendorDriver"));

const organizationVendorRoute = {
  icon: EmojiTransportationIcon,
  name: "Cab Vendor",
  link: "/cab-vendor",
  path: "cab-vendor",
  index: 55,
  superAdminView: false,
  element: "",
  children: [
    {
      path: "vendor",
      element: <OrganizationVendorList />,
      name: "Vendors",
      permission: "Vendor-Read",
      link: "/cab-vendor/vendor",
      icon: EmojiTransportationIcon,
      index: 3,
      superAdminView: false,
    },
    {
      path: "/cab-vendor/vendor/:id",
      element: <OrganizationVendorView />,
    },
    {
      path: "/cab-vendor/vendor/:id/orgVendorCabs",
      element: <OrgVendorCabs />,
    },
    {
      path: "/cab-vendor/vendor/:id/orgVendorDrivers",
      element: <OrgVendorDrivers />,
    },
  ],
};
export default organizationVendorRoute;
